/**
 * class for a user
 */

export interface User {
  welcomeMsg: string;
  account: any;
  filteredAccount: any;
  menu: any;
  publicAccount: any;
  accountPublicURL: any;
  accountControlDocument: any;
  accountGroupConfigDocument: any;
}
